











import { Component, Prop, Vue } from 'vue-property-decorator';
import TextInput from './_text.input.vue';
@Component({
  components: {
    'text-input': TextInput
  },
})
export default class InputAddress extends Vue {
  @Prop()
  placeholder!: string;
  public label = 'Dirección de residencia';
  public error = '';
  public icon = 'place'

  onChange($text) {
    console.error($text)
      if($text.length === 0){
          this.error = 'Dirección invalida';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
